import { FormField } from '../../../types/form-builder.types';
import { Star } from 'lucide-react';
import { cn } from '@shondalai/ui-commons';
import { useState } from 'react';

interface RatingFieldProps {
  field: FormField;
  value: any;
  onChange: (value: any) => void;
}

export function RatingField({ field, value, onChange }: RatingFieldProps) {
  const config = field.config;
  const [hoverValue, setHoverValue] = useState<number | null>(null);
  const maxRating = config.ratingMax || 5;
  const currentValue = value || 0;

  return (
    <div className="flex gap-1.5">
      {Array.from({ length: maxRating }, (_, index) => {
        const ratingValue = index + 1;
        const isActive = hoverValue ? ratingValue <= hoverValue : ratingValue <= currentValue;

        return (
          <button
            key={index}
            type="button"
            onClick={() => onChange(ratingValue)}
            onMouseEnter={() => setHoverValue(ratingValue)}
            onMouseLeave={() => setHoverValue(null)}
            className="transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-1 rounded"
            style={{
              '--tw-ring-color': 'var(--ef-accent, #3B82F6)',
              '--tw-ring-opacity': '0.2'
            } as React.CSSProperties}
          >
            <Star
              className={cn(
                "w-7 h-7 transition-colors duration-200"
              )}
              style={{
                fill: isActive ? 'var(--ef-accent, #F59E0B)' : 'transparent',
                color: isActive ? 'var(--ef-accent, #F59E0B)' : 'var(--ef-border, #E2E8F0)'
              }}
              strokeWidth={1.5}
            />
          </button>
        );
      })}
    </div>
  );
}
